"use client";
import Link from "@/components/ui/Link";
import { pushEvent } from "@/lib/analytics/gtm";
import { analyticsEvents } from "@/lib/analytics/events";
import { hashtagSlug } from "@/lib/seo/hashtag-slug";

interface TagChipLinkProps {
  tag: string;
  className?: string;
  children: React.ReactNode;
}

export function TagChipLink({ tag, className, children }: TagChipLinkProps) {
  return (
    <Link
      href={`/hashtag/${encodeURIComponent(hashtagSlug(tag))}`}
      className={className}
      onClick={() => pushEvent(analyticsEvents.hashtag_click, { tag, source: "card" })}
    >
      {children}
    </Link>
  );
}
